import React from 'react';

import './Paper.scoped.scss';

// Reusable paper component, adds modal/popower background style to component, Will ensure consistency across project
// Has no props
// Example:

//  <Paper>
//    <div>
//      My awesome dialog content
//    </div>
//  </Paper>

const Paper: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <div className="paper-container">{children}</div>;
};

export default Paper;
